// Resolves which model the current page should show, for code that used to
// just read ?modelId= directly off the URL.
//
// A direct ?modelId= is trusted as-is (normal, logged-in /scene?modelId=...
// flow — Scene is only ever mounted there behind a real ProtectedRoute
// login, never as part of the share flow).
//
// Shared viewing never changes the address bar at all — SharedScene.js
// validates the /s/<shareId> link and renders <Scene /> directly in place,
// stashing the token + resolved modelId in sessionStorage first. The
// modelId itself never appears in any URL the visitor sees, only the share
// token does (the link they were given).
export function getViewingModelId(search = window.location.search) {
  const params = new URLSearchParams(search);
  const direct = params.get('modelId');
  if (direct) return direct;
  if (sessionStorage.getItem('shareToken')) return sessionStorage.getItem('shareModelId');
  return null;
}
